import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ModelIcon } from '../../assets/icons/sidebar/sidebar-device.svg';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setPageTitle } from '../../redux/slices/PageTitleSlice';

import Local from './components/Local';

/**
 * Firmware Version management page — displays uploaded firmware artifacts.
 * @returns {React.JSX.Element} FirmwareVersionManagement page
 */
function FirmwareVersionManagement() {
  const { t } = useTranslation('station');
  const dispatch = useAppDispatch();
  const { totalResults } = useAppSelector((state) => state.firmwareVersion);

  useEffect(() => {
    dispatch(
      setPageTitle({
        title: t('firmwareVersion'),
        count: totalResults,
        icon: <ModelIcon />,
      }),
    );
  }, [dispatch, totalResults]);

  return (
    <div className="firmware-version-management-wrap">
      <div className="firmware-version-management-container">
        <div className="table-content">
          <Local />
        </div>
      </div>
    </div>
  );
}

export default FirmwareVersionManagement;
